//一些公用方法
//跨域 ajax方法
function postJson(url, info, callback, cross, type) {
    var t = Date.parse(new Date()) / 1000
    info.t = t
    $.ajax({
        type: type || "POST",
        url: url,
        data: JSON.stringify(info),
        headers: {
            Sign: md5(t + '_DellEmc')
        },
        dataType: "json",
        contentType: 'text/plain',
        crossDomain: cross || false,
        xhrFields: {
            withCredentials: cross || false
        },
        success: function (data) {
            if( typeof callback === "function"){
                callback(data);
            }
        },
        error: function (data) {
            console.log(data);
            if(data.status === 401){
                if( typeof callback === "function"){
                    callback(data.responseJSON);
                }
            }
            if (window.isDebug) {
                console.log(data);
            }
        }
    });
}

function getJson (url, info, callback, cross) {
    $.ajax({
        type: "GET",
        url: url,
        data: info,
        dataType: "json",
        contentType: 'text/plain',
        crossDomain: cross || false,
        xhrFields: {
            withCredentials: cross || false
        },
        success: function (data) {
            callback(data);
        },
        error: function (data) {
            if (window.isDebug) {
                console.log(data);
            }
        }
    });
}
